<template>
  <div class="lg:flex items-start">
    <div class="p-8 md:p-12 text-white bg-gradient-to-tr from-blue-500 to-blue-accent rounded-md lg:max-w-sm">
      <div class="text-lg md:text-xl space-y-8 max-w-xl">
        <p>
          Bitte beachten Sie, dass für<br>
          <template v-if="'coupon' in methods">
            <strong class="opacity-80">„{{ event.name }}“</strong> der <strong>Vorverkauf für Abonnent*innen</strong> und <strong>Förderkreis&shy;mitglieder</strong> läuft.
          </template>
          <template v-else>
          <strong class="opacity-80">„{{ event.name }}“</strong> der <strong>Vorverkauf für Förderkreis&shy;mitglieder</strong> läuft.
          </template>
        </p>
        <p>
          Der freie Ticketverkauf beginnt am {{ formatDate(event.presale_auth, 'DD.MM.YYYY [um] HH:mm [Uhr]') }}.
        </p>
      </div>
    </div>
    <div class="flex-1 space-y-4 mt-8 lg:mt-0 lg:ml-16">
      <div v-for="(method, key) in methods" :key="key">
        <Auth
          v-bind="method"
          :event="event"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Auth from 'Web/Shared/Auth.vue';
import formatDate from '@/helpers/formatDate';

export default {
  inheritAttrs: false,
  components: {
    Auth,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
    methods: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      formatDate
    }
  }
}
</script>
